import { useState } from 'react';
import s from './CinematicMovie.module.scss';
import { useLanguage } from '../contexts/LanguageContext';
import { cinematicMovieText } from '../i18n/cinematicMovie';

const YOUTUBE_URL = 'https://youtu.be/MQA5nq0PXlA';
const CINEMATIC_IMAGE_URL =
  'https://res.cloudinary.com/drxijtp8g/image/upload/v1784531285/IMG_1066_sd05qe.webp';

const getYoutubeEmbedUrl = (url) => {
  if (!url || typeof url !== 'string') return '';

  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace('www.', '');
    let id = '';

    if (host === 'youtu.be') {
      id = parsed.pathname.replace('/', '');
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (parsed.pathname.startsWith('/shorts/')) {
        id = parsed.pathname.split('/')[2];
      } else if (parsed.pathname.startsWith('/embed/')) {
        id = parsed.pathname.split('/')[2];
      } else {
        id = parsed.searchParams.get('v') || '';
      }
    }

    return id
      ? `https://www.youtube.com/embed/${id}?autoplay=1&controls=1&playsinline=1&modestbranding=1&rel=0&vq=hd1080&hd=1`
      : '';
  } catch {
    return '';
  }
};

const CinematicMovie = () => {
  const { lang } = useLanguage();
  const movieText = cinematicMovieText[lang] || cinematicMovieText.JP;
  const youtubeEmbedUrl = getYoutubeEmbedUrl(YOUTUBE_URL);

  const [isOpen, setIsOpen] = useState(false);

  const openMovie = () => {
    if (!youtubeEmbedUrl) return;

    setIsOpen(true);
  };

  const closeMovie = () => {
    setIsOpen(false);
  };

  return (
    <>
      <section className={s.root}>
        <img
          src={CINEMATIC_IMAGE_URL}
          alt=""
          className={s.bgImage}
          loading="lazy"
          fetchPriority="low"
          decoding="async"
          width="1600"
          height="900"
          aria-hidden="true"
        />

        <div className={s.overlay}></div>

        <div className={s.content}>
          <p className={s.kicker}>Cinematic Movie</p>

          <h2>Watch our film</h2>

          <p className={s.text}>
            {movieText.textLines.map((line, index) => (
              <span key={line}>
                {line}
                {index !== movieText.textLines.length - 1 && <br />}
              </span>
            ))}
          </p>

          <button className={s.playBtn} type="button" onClick={openMovie}>
            <span className={s.playIcon}>
              <svg viewBox="0 0 24 24">
                <path d="M9 7l8 5-8 5V7Z" />
              </svg>
            </span>

            <span className={s.playLabel}>Play Movie</span>

            <span className={s.arrowIcon}>
              <svg viewBox="0 0 24 24">
                <path d="M5 12h14" />
                <path d="M13 6l6 6-6 6" />
              </svg>
            </span>
          </button>
        </div>
      </section>

      {isOpen && (
        <div className={s.movieModal}>
          <button className={s.closeBtn} type="button" onClick={closeMovie}>
            ×
          </button>

          <button
            type="button"
            className={s.movieBackdrop}
            onClick={closeMovie}
            aria-label="動画を閉じる"
          />

          <div className={s.movieInner}>
            <iframe
              className={s.movie}
              src={youtubeEmbedUrl}
              title="Cinematic movie"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CinematicMovie;
